module.exports = __webpack_public_path__ + "img/DE01189.69add04e.png";